import type { ReactNode } from "react";
import { Row } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { Typography } from "@circle-react-uikit/Typography";
import { ShimmerText } from "./ShimmerText";

interface PreviewTitleProps {
  shimmer?: boolean;
  subtitle: ReactNode;
  title: ReactNode;
}

export const PreviewTitle = ({
  title,
  subtitle,
  shimmer = false,
}: PreviewTitleProps) => (
  <div className="mb-7">
    <Typography.LabelXs
      textTransform="uppercase"
      weight="semibold"
      color="text-light"
    >
      {subtitle}
    </Typography.LabelXs>
    {title ? (
      <Typography.TitleLg
        color="text-black-900"
        tracking="tighter"
        weight="bold"
      >
        <ShimmerText animate={shimmer}>{title}</ShimmerText>
      </Typography.TitleLg>
    ) : (
      <div className="mt-2">
        <Row xxl almostFull />
      </div>
    )}
  </div>
);
